import { render, staticRenderFns } from "./relationdata.vue?vue&type=template&id=8b928dd6&scoped=true&"
import script from "./relationdata.vue?vue&type=script&lang=js&"
export * from "./relationdata.vue?vue&type=script&lang=js&"
import style0 from "./relationdata.vue?vue&type=style&index=0&id=8b928dd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b928dd6",
  null
  
)

export default component.exports